import {mapActions, mapGetters, mapMutations} from "vuex";

export const useIndividualPacking = {
    computed: {
        ...mapGetters('moduleIndividualPacking', {
            getCurrentFormView: 'getCurrentFormView',
            getFormStages: 'getFormStages',
            getFormValueByKey: 'getFormValueByKey',
            getForm: 'getForm',
        }),
    },
    methods: {
        ...mapActions('moduleIndividualPacking',{
            requestFormStages: 'requestFormStages',
            sendIndividualPacking: 'sendIndividualPacking',
        }),
        ...mapMutations('moduleIndividualPacking', {
            setCurrentFormView: 'setCurrentFormView',
            setFormKey: 'setFormKey',
        })
    }
}
